export const sizes = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopL: 1440,
  desktop: 2560,
};
export const devices = {
    mobileS: `(min-width: ${sizes.mobileS}px)`,
    mobileM: `(min-width: ${sizes.mobileM}px)`,
    mobileL: `(min-width: ${sizes.mobileL}px)`,
    tablet: `(min-width: ${sizes.tablet}px)`,
    laptop: `(min-width: ${sizes.laptop}px)`,
    laptopL: `(min-width: ${sizes.laptopL}px)`,
    desktop: `(min-width: ${sizes.desktop}px)`,
  },
  siteInfo = {
    tel: "07030940870",
    email: "support@vhicasar.com",
  },
  socialInfo = [],
  THEME_KEY = "casa-theme",
  USER_TOKEN = "casa-USER-TOKEN",
  hostURL = "https://api.vhicasar.com",
  sitename = "Vhicasar Homes",
  REDIRECT_URI = "casa-redirect",
  reviews = [
    {
      name: "John D.",
      review: `${sitename} exceeded my expectations, I'll continue to be a loyal customer.`,
    },
    {
      name: "Emily S.",
      review: `I've tried other service platforms before, but none compare to the ease and efficiency of ${sitename}. From plumbers to personal trainers, I've found top-notch professionals every time. Plus, the interface is so user-friendly.`,
    },
    {
      name: "David M.",
      review: `${sitename} is a lifesaver! Whether I need a last-minute house cleaner or a skilled handyman, I can always count on ${sitename} to connect me with reliable professionals. It's like having a personal concierge at my fingertips.`,
    },
    {
      name: "Sarah H.",
      review: `I was skeptical at first, but ${sitename} exceeded all my expectations. The quality of service providers available on the platform is unmatched, and the booking process is seamless. I'll definitely be using ${sitename} for all my future needs.`,
    },
    {
      name: "Michael L.",
      review: `I can't thank ${sitename} enough for making my life easier. As a busy mom, finding trustworthy service providers used to be a headache. Now, with ${sitename}, I can book everything from childcare to pet sitting with confidence.`,
    },
    {
      name: "Rachel P.",
      review: `${sitename} has completely revolutionized the way I find service providers. The platform is incredibly intuitive, and I love the variety of professionals available. Whether I need a yoga instructor or a graphic designer, ${sitename} has me covered.`,
    },
    {
      name: "Daniel B.",
      review: `I've been using ${sitename} for a few months now, and I'm consistently impressed by the caliber of professionals I find on the platform. Not only are they skilled at what they do, but they're also punctual and courteous. Highly recommend!`,
    },
    {
      name: "Sophia K.",
      review: `I've saved so much time and energy since I started using ${sitename}. Instead of scouring the internet for service providers, I can simply hop on the platform and find exactly what I need in minutes. It's a game-changer for sure.`,
    },
    {
      name: "Olivia R.",
      review: `${sitename} is a godsend for anyone who values convenience and quality. I've used it to book everything from electricians to caterers, and I've never been disappointed. Plus, the customer support team is always there to help if I have any questions.`,
    },
    {
      name: "James T.",
      review: `If you're tired of unreliable service providers, look no further than ${sitename}. I've been burned in the past by other platforms, but ${sitename} has restored my faith. The professionals on this platform are vetted and trustworthy, and the results speak for themselves.`,
    },
  ],
  faqData = [
    {
      question: `How does ${sitename} vet its service providers?`,
      answer:
        `${sitename} thoroughly vets its service providers through a rigorous screening process that includes background checks, reviews, and verification of licenses and certifications.`,
    },
    {
      question: `Is ${sitename} available in my area?`,
      answer:
        `${sitename} is constantly expanding its coverage area. Please check our website or contact customer support to see if ${sitename} services are available in your area.`,
    },
    {
      question: `What types of home services does ${sitename} offer?`,
      answer:
        `${sitename} offers a wide range of home services, including cleaning, repairs, maintenance, landscaping, and more. Visit our website to see a full list of services.`,
    },
    {
      question: `Can I schedule recurring appointments with ${sitename}?`,
      answer:
        `Yes, ${sitename} offers the option to schedule recurring appointments for your convenience. Simply specify your desired frequency, and we'll take care of the rest.`,
    },
    {
      question: `Are the prices for ${sitename} services fixed, or do they vary?`,
      answer:
        `The prices for ${sitename} services may vary depending on factors such as the type of service, the size of the job, and your location. However, we strive to provide transparent pricing upfront so you know what to expect.`,
    },
  ];
